import { render } from "./registrationStep5.vue?vue&type=template&id=5ebbe935&scoped=true"
import script from "./registrationStep5.vue?vue&type=script&lang=js"
export * from "./registrationStep5.vue?vue&type=script&lang=js"

import "./registrationStep5.vue?vue&type=style&index=0&id=5ebbe935&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebbe935"]])

export default __exports__